/**
 * assets/collection-filters.js
 * Progressively enhances the native <form data-facet-form> (which already
 * works via full-page GET requests) into instant, no-reload filtering using
 * Shopify's section-rendering API: fetch the same URL with
 * `?section_id=main` appended, and Shopify returns just this section's
 * re-rendered HTML — no separate JSON filtering API to maintain.
 */
(function () {
  const wrapper = document.querySelector("[data-collection-section]");
  if (!wrapper) return;

  const form = wrapper.querySelector("[data-facet-form]");
  const resultsGrid = wrapper.querySelector("[data-product-results]");
  const countEl = wrapper.querySelector("[data-product-count]");
  const filterToggle = wrapper.querySelector("[data-filter-toggle]");
  const filterPanel = wrapper.querySelector("#CollectionFilters");
  const sectionId = wrapper.dataset.collectionSection;

  if (filterToggle && filterPanel) {
    filterToggle.addEventListener("click", () => {
      const expanded = filterToggle.getAttribute("aria-expanded") === "true";
      filterToggle.setAttribute("aria-expanded", String(!expanded));
      filterPanel.classList.toggle("is-open", !expanded);
    });
  }

  function currentUrl() {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (value) params.append(key, value);
    }
    return `${window.location.pathname}?${params.toString()}`;
  }

  async function applyFilters(pushState) {
    const url = currentUrl();
    const sectionUrl = `${url}${url.includes("?") ? "&" : "?"}section_id=main`;

    resultsGrid && resultsGrid.setAttribute("aria-busy", "true");

    try {
      const res = await fetch(sectionUrl);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newGrid = doc.querySelector("[data-product-results]");
      const newEmptyState = doc.querySelector(".collection-empty-state");
      const newCount = doc.querySelector("[data-product-count]");
      const newFilters = doc.querySelector("#CollectionFilters");

      const container = resultsGrid ? resultsGrid.parentElement : wrapper.querySelector(".container");
      if (newGrid) {
        if (resultsGrid) resultsGrid.replaceWith(newGrid);
      } else if (newEmptyState) {
        const target = wrapper.querySelector("[data-product-results], .collection-empty-state");
        if (target) target.replaceWith(newEmptyState);
      }

      if (countEl && newCount) countEl.textContent = newCount.textContent;
      if (filterPanel && newFilters) filterPanel.innerHTML = newFilters.innerHTML;

      if (pushState) window.history.pushState({}, "", url);

      document.dispatchEvent(new CustomEvent("dyet:filter_apply", { detail: { url } }));
    } catch (err) {
      // Fall back to a real navigation if the fetch fails for any reason.
      window.location.href = url;
    } finally {
      resultsGrid && resultsGrid.setAttribute("aria-busy", "false");
    }
  }

  form.addEventListener("change", (e) => {
    if (e.target.matches("[data-facet-input], [data-sort-select]")) {
      applyFilters(true);
    }
  });

  form.addEventListener("click", (e) => {
    const resetLink = e.target.closest("[data-reset-filters]");
    if (resetLink) {
      e.preventDefault();
      window.history.pushState({}, "", resetLink.href);
      fetch(`${resetLink.href}?section_id=${sectionId}`)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const newSection = doc.querySelector("[data-collection-section]");
          if (newSection) wrapper.replaceWith(newSection);
        });
    }
  });

  window.addEventListener("popstate", () => applyFilters(false));
})();
